var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTaskGreen(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 12C3 7.7574 3 5.6361 4.3176 4.3176C5.637 3 7.7574 3 12 3C16.2426 3 18.3639 3 19.6815 4.3176C21 5.637 21 7.7574 21 12C21 16.2426 21 18.3639 19.6815 19.6815C18.3648 21 16.2426 21 12 21C7.7574 21 5.6361 21 4.3176 19.6815C3 18.3648 3 16.2426 3 12Z",
    stroke: "#008080",
    strokeWidth: 1.3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7 14.6987L7.97155 15.7409L10.4 13.1356M7 8.6198L7.97155 9.6619L10.4 7.05664",
    stroke: "#008080",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9492 8.79297H17.1992M12.9492 14.8719H17.1992",
    stroke: "#008080",
    strokeWidth: 1.3,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTaskGreen);
export default __webpack_public_path__ + "static/media/Task_Green.63c53ea0a33400b20c8573c541f93116.svg";
export { ForwardRef as ReactComponent };